import { Component } from 'react';
import html2canvas from 'html2canvas';
import PropTypes from 'prop-types';

export default class Printer extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
  };

  state = {
    isSaving: false,
  };

  getDate = () => {
    const date = new Date();
    let sdate = `${date.getFullYear()}-`;
    sdate +=
      date.getMonth() > 8 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    sdate += '-';
    sdate += date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;

    return sdate;
  };

  saveImage = elemId => {
    this.setState({
      isSaving: true,
    });
    setTimeout(() => {
      // TODO https://github.com/tsayen/dom-to-image
      html2canvas(document.querySelector(elemId), {
        scale: 1,
        logging: process.env.NODE_ENV !== 'production',
      }).then(canvas => {
        this.saveAs(
          canvas.toDataURL('image/png'),
          `comunicado-${this.getDate()}.jpg`
        );
        this.setState({
          isSaving: false,
        });
      });
    }, 500);
  };

  saveAs = (uri, filename) => {
    const link = document.createElement('a');
    if (typeof link.download === 'string') {
      link.href = uri;
      link.download = filename;

      // Firefox requires the link to be in the body
      document.body.appendChild(link);

      // simulate click
      link.click();

      // remove the link when done
      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  };

  render() {
    const { children } = this.props;
    const { isSaving } = this.state;
    return children({
      isSaving,
      saveImage: this.saveImage,
    });
  }
}
